import {UserAction} from '../userAction';
import {UserCableRequirement} from '../plug/plugType';
import {InfraStatus} from '../../enum/infraStatus';
import {PlugDto} from '../plug/plug';

export interface ChargePointDto {
    id?: string;
    maxPowerInW?: number;
    stationAlias?: string;
    stationVisualId?: string;
    stationId?: string;
    /**
     * depends on TA, subscriptionPack and ConnectedUser
     */
    userActions?: UserAction[];
    /**
     * depends on TA, subscriptionPack and ConnectedUser and InfraElement Status on the request moment
     */
    currentUserActions?: UserAction[];
    infraStatus?: InfraStatus;
    plugs?: PlugDto[];
    visualId?: string;
    userCableRequirement?: UserCableRequirement;
    lastUsageDate?: string;
}

export enum ChargePointLazyCategory {
    /**
     * depends on TA, subscriptionPack and ConnectedUser
     */
    USER_ACTIONS = 'USER_ACTIONS',
    /**
     * depends on TA, subscriptionPack and ConnectedUser and InfraElement Status on the request moment
     */
    CURRENT_USER_ACTIONS = 'CURRENT_USER_ACTIONS',
    PLUG_DTO = 'PLUG_DTO',
}
